// Root
export const SET_LOADING = 'SET_LOADING';

// User
export const SET_USER = 'SET_USER';

// Version
export const SET_VERSION = 'SET_VERSION';
export const SET_DEPLOYMENT = 'SET_DEPLOYMENT';

// tables
export const UPDATE_TABLES_STATUS = 'UPDATE_TABLES_STATUS';
export const UPDATE_TABLE_SORTING = 'UPDATE_TABLE_SORTING';
export const UPDATE_TABLE_COUNT = 'UPDATE_TABLE_COUNT';
export const UPDATE_TABLE_CURRENT_PAGE = 'UPDATE_TABLE_CURRENT_PAGE';
export const UPDATE_TABLE_PER_PAGE = 'UPDATE_TABLE_PER_PAGE';
export const UPDATE_TABLE_READY = 'UPDATE_TABLE_READY';
export const UPDATE_TABLE_ROWS = 'UPDATE_TABLE_ROWS';
export const UPDATE_TABLE_COLUMNS_CONFIG = 'UPDATE_TABLE_COLUMNS_CONFIG';
export const UPDATE_TABLE_STICKY_COLUMNS = 'UPDATE_TABLE_STICKY_COLUMNS';
export const UPDATE_TABLE_ENABLE_PAGINATION = 'UPDATE_TABLE_ENABLE_PAGINATION';
export const ADD_TABLE = 'ADD_TABLE';
export const REMOVE_TABLE = 'REMOVE_TABLE';

// Filters
export const APPLY_FILTERS = 'APPLY_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';

// Tabs
export const ADD_TAB = 'ADD_TAB';
export const REMOVE_TAB = 'REMOVE_TAB';
export const UPDATE_TAB = 'UPDATE_TAB';
export const PURGE_TABS = 'PURGE_TABS';

// Forms
export const UPDATE_FORM = 'UPDATE_FORM';
export const RESET_FORM = 'RESET_FORM';
